import { useEffect, useRef } from "react";
import { T } from "./todoTokens";

/* Directive §10 — one toast, bottom-centre, 5 seconds, Undo in accent. */
export const UndoToast = ({ toast, onClose }) => {
  const done = useRef(false);
  useEffect(() => {
    done.current = false;
    const id = setTimeout(() => { if (!done.current) onClose(); }, 5000);
    return () => clearTimeout(id);
  }, [toast, onClose]);

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[80] rounded-[9px] px-4 py-2.5 flex items-center gap-4"
      style={{ background: T.accentInk, color: "#fff", boxShadow: "0 10px 28px rgba(18,18,18,0.3)" }}
      data-testid="todos-toast">
      <span className="text-[13px]">{toast.text}</span>
      {toast.undo && (
        <button onClick={() => { done.current = true; toast.undo(); onClose(); }}
          className="text-[13px] font-bold" style={{ color: T.accent }} data-testid="todos-toast-undo">Undo</button>
      )}
      {toast.retry && (
        <button onClick={() => { done.current = true; toast.retry(); onClose(); }}
          className="text-[13px] font-bold" style={{ color: T.accent }} data-testid="todos-toast-retry">Retry</button>
      )}
    </div>
  );
};
